// Código JavaScript personalizado del tema

// ── Subscription cart guard ──────────────────────────────────────────────────
// Works for both the main product page AND the quick-add modal.
// The submit interceptor lives at document level (capture phase) so it catches
// ALL add-to-cart forms — including those injected dynamically by quick-add.js.
(function () {
  var bypassSubmit = false;

  // Utility to parse request body of fetch calls (FormData, JSON, URL-encoded)
  function parseRequestBody(body) {
    if (!body) return {};
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        var params = {};
        body.split('&').forEach(function(pair) {
          var parts = pair.split('=');
          if (parts[0]) {
            params[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1] || '');
          }
        });
        return params;
      }
    }
    if (body instanceof FormData) {
      var params = {};
      body.forEach(function(value, key) {
        params[key] = value;
      });
      return params;
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      var params = {};
      body.forEach(function(value, key) {
        params[key] = value;
      });
      return params;
    }
    return {};
  }

  // ── FETCH INTERCEPTOR (FIREWALL) ───────────────────────────────────────────
  // Intercepts direct AJAX requests to `/cart/add` and `/cart/change`
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) ? input.url : '';

    // 1. Intercept add-to-cart requests
    if (url.indexOf('/cart/add') !== -1 && init && init.body) {
      try {
        var params = parseRequestBody(init.body);
        var isSubscription = false;
        var productIds = [];
        var variantIds = [];

        // Check top-level selling plan
        if (params.selling_plan && params.selling_plan.toString().trim() !== '') {
          isSubscription = true;
          if (params.id) variantIds.push(parseInt(params.id, 10));
          if (params['product-id']) productIds.push(parseInt(params['product-id'], 10));
        }

        // Check bundle items selling plan
        Object.keys(params).forEach(function(key) {
          if (key.indexOf('[selling_plan]') !== -1 && params[key] && params[key].toString().trim() !== '') {
            isSubscription = true;
            // Extract item index to find its variant ID
            var match = key.match(/items\[(\d+)\]/);
            if (match) {
              var idx = match[1];
              var idKey = 'items[' + idx + '][id]';
              if (params[idKey]) {
                variantIds.push(parseInt(params[idKey], 10));
              }
            }
          }
        });

        if (isSubscription) {
          console.log('[SubscriptionGuard] Intercepting fetch /cart/add - subscription detected', { variantIds: variantIds, productIds: productIds });

          // Force quantity to 1 if it's in the request
          if (init.body instanceof FormData) {
            if (init.body.has('quantity') && parseInt(init.body.get('quantity'), 10) > 1) {
              init.body.set('quantity', '1');
            }
            variantIds.forEach(function(vId, idx) {
              var qtyKey = 'items[' + idx + '][quantity]';
              if (init.body.has(qtyKey)) {
                init.body.set(qtyKey, '1');
              }
            });
          } else if (typeof init.body === 'string') {
            if (init.body.indexOf('{') === 0) {
              var data = JSON.parse(init.body);
              if (data.quantity > 1) data.quantity = 1;
              if (data.items) {
                data.items.forEach(function(item) {
                  if (item.selling_plan && item.quantity > 1) item.quantity = 1;
                });
              }
              init.body = JSON.stringify(data);
            }
          }

          // Check if already in cart
          return fetchCart().then(function(cart) {
            var alreadySubscribed = cart.items.some(function(item) {
              if (item.selling_plan_allocation == null) return false;
              if (variantIds.indexOf(item.variant_id) !== -1) return true;
              if (productIds.indexOf(item.product_id) !== -1) return true;
              return false;
            });

            if (alreadySubscribed) {
              console.log('[SubscriptionGuard] 🚫 Blocking duplicate subscription add via fetch');
              var errResponse = {
                status: 422,
                message: 'Cart Error',
                description: 'Ya tienes esta suscripción en tu carrito.'
              };
              return new Response(JSON.stringify(errResponse), {
                status: 422,
                headers: { 'Content-Type': 'application/json' }
              });
            }

            return originalFetch(input, init);
          });
        }
      } catch (e) {
        console.error('[SubscriptionGuard] Error in /cart/add interception:', e);
      }
    }

    // 2. Intercept quantity change requests (cart drawer/page updates)
    if (url.indexOf('/cart/change') !== -1 && init && init.body) {
      try {
        var data = null;
        var line = null;
        var qty = null;

        if (typeof init.body === 'string' && init.body.indexOf('{') === 0) {
          data = JSON.parse(init.body);
          line = data.line;
          qty = data.quantity;
        }

        if (line !== null && qty > 1) {
          // Check the DOM for this item line index
          var inputEl = document.getElementById('Drawer-quantity-' + line) || document.getElementById('Quantity-' + line);
          var isSubscription = false;

          if (inputEl) {
            var cartItem = inputEl.closest('.cart-item');
            isSubscription = inputEl.getAttribute('max') === '1' || 
                             (cartItem && cartItem.textContent.toLowerCase().indexOf('mensual') !== -1);
          }

          if (isSubscription) {
            console.log('[SubscriptionGuard] Intercepted /cart/change: forcing quantity to 1 for line', line);
            data.quantity = 1;
            init.body = JSON.stringify(data);
          }
        }
      } catch (e) {
        console.error('[SubscriptionGuard] Error in /cart/change interception:', e);
      }
    }

    return originalFetch.apply(this, arguments);
  };

  function cartHasSubscription(productFormEl, productId, cart) {
    var variantInput = productFormEl.querySelector('input[name="id"]');
    var variantId = variantInput ? parseInt(variantInput.value, 10) : null;

    var scope = getScope(productFormEl);
    var requiredChildProducts = [];
    var scripts = scope.querySelectorAll('.kg-subscription__product-data');
    
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (data && data.variants) {
          var productVariantIds = [];
          data.variants.forEach(function(v) { productVariantIds.push(v.id); });
          if (productVariantIds.length > 0) {
            requiredChildProducts.push(productVariantIds);
          }
        }
      } catch(e) {}
    }

    var cartVariantIds = cart.items.map(function(i) { return i.variant_id; });
    
    // Check if ALL required child products (at least one variant from each) are present in the cart
    var hasAllChildProducts = requiredChildProducts.length > 0 && requiredChildProducts.every(function(productVariants) {
       return productVariants.some(function(vId) { return cartVariantIds.indexOf(vId) !== -1; });
    });

    var hasNormalSubscription = cart.items.some(function (item) {
      if (item.selling_plan_allocation == null) return false;
      if (item.product_id === productId) return true;
      if (variantId && item.variant_id === variantId) return true;
      return false;
    });

    return hasNormalSubscription || hasAllChildProducts;
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // Find the nearest product-form ancestor and return its context
  function getGuardContext(form) {
    var productFormEl = form.closest('product-form');
    if (!productFormEl || !productFormEl.dataset.productId) return null;

    var productId = parseInt(productFormEl.dataset.productId, 10);
    var submitBtn = productFormEl.querySelector('button[name="add"]');
    var warningEl = productFormEl.querySelector('.subscription-cart-warning');

    return { productFormEl: productFormEl, productId: productId, submitBtn: submitBtn, warningEl: warningEl };
  }

  // Subscription radios live in sibling blocks OUTSIDE product-form.
  // Climb to the nearest .wt-product wrapper which contains both form and radios.
  function getScope(productFormEl) {
    return productFormEl.closest('.wt-product') || document;
  }

  function isSubscriptionSelectedIn(productFormEl) {
    var scope = getScope(productFormEl);

    // 1. Check if the bundle subscription radio is explicitly checked
    var checked = scope.querySelector('input[name="selling_plan"]:checked');
    if (checked) {
      if (checked.dataset.radioType === 'selling_plan' || checked.value !== '') return true;
      if (checked.dataset.radioType === 'one_time_purchase' || checked.value === '') return false;
    }

    // 2. Check FormData
    var form = productFormEl.tagName === 'FORM' ? productFormEl : productFormEl.querySelector('form');
    if (form) {
      try {
        var fd = new FormData(form);
        var sp = fd.get('selling_plan');
        if (sp && sp.toString().trim() !== '') return true;
      } catch(e) {}
    }

    // 3. Fallback to hidden inputs
    var hiddenInput = scope.querySelector('input[type="hidden"][name="selling_plan"]');
    if (hiddenInput && hiddenInput.value && hiddenInput.value.trim() !== '') return true;

    return false;
  }

  function setBlockedFor(ctx, blocked) {
    console.log('[SubscriptionGuard] setBlocked:', blocked, '| productId:', ctx.productId);
    if (ctx.submitBtn) {
      ctx.submitBtn.disabled = blocked;
      ctx.submitBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    }
    if (ctx.warningEl) ctx.warningEl.hidden = !blocked;
  }

  // ── DOCUMENT-LEVEL CAPTURE: intercepts ALL add-to-cart form submits ────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form) return;

    var isAddToCartForm = form.getAttribute('data-type') === 'add-to-cart-form' ||
                          form.classList.contains('wt-product__add-to-cart_form') ||
                          form.closest('product-form') !== null;

    if (!isAddToCartForm) return;

    console.log('[SubscriptionGuard] submit captured | bypassSubmit:', bypassSubmit, '| form:', form.id);

    if (bypassSubmit) {
      bypassSubmit = false;
      console.log('[SubscriptionGuard] ✅ Bypass active — letting product-form.js proceed');
      return;
    }

    var ctx = getGuardContext(form);
    if (!ctx) {
      console.warn('[SubscriptionGuard] Could not find product-form context with data-product-id');
      return;
    }

    if (!isSubscriptionSelectedIn(ctx.productFormEl)) {
      console.log('[SubscriptionGuard] Not a subscription — passing through');
      return;
    }

    // Block submission immediately to consult cart
    e.preventDefault();
    e.stopImmediatePropagation();
    console.log('[SubscriptionGuard] Subscription detected — querying cart...', '| productId:', ctx.productId);

    fetchCart().then(function (cart) {
      var alreadySubscribed = cartHasSubscription(ctx.productFormEl, ctx.productId, cart);
      console.log('[SubscriptionGuard] alreadySubscribed:', alreadySubscribed);

      if (alreadySubscribed) {
        console.log('[SubscriptionGuard] 🚫 BLOCKED duplicate add');
        setBlockedFor(ctx, true);
        // Dispatch an error event so the error message shows up properly
        if (ctx.productFormEl && typeof ctx.productFormEl.handleErrorMessage === 'function') {
          ctx.productFormEl.handleErrorMessage('Ya tienes esta suscripción en tu carrito.');
        }
      } else {
        console.log('[SubscriptionGuard] ✅ OK — re-dispatching submit');
        setBlockedFor(ctx, false);
        bypassSubmit = true;
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });

  }, true /* capture phase */);

  // ── UI REFRESH: disable button if subscription already in cart ────────────
  function refreshUIForForm(productFormEl) {
    if (!productFormEl || !productFormEl.dataset.productId) return;
    if (productFormEl.dataset.guardInit) return; // Avoid duplicate listeners
    productFormEl.dataset.guardInit = 'true';

    var productId = parseInt(productFormEl.dataset.productId, 10);
    var submitBtn = productFormEl.querySelector('button[name="add"]');
    var warningEl = productFormEl.querySelector('.subscription-cart-warning');

    console.log('[SubscriptionGuard] Initializing UI for productId:', productId);

    function refresh() {
      fetchCart().then(function (cart) {
        var isSubscription = isSubscriptionSelectedIn(productFormEl);
        var blocked = cartHasSubscription(productFormEl, productId, cart) && isSubscription;
        console.log('[SubscriptionGuard] refreshUI → productId:', productId, '| blocked:', blocked);
        if (submitBtn) {
          submitBtn.disabled = blocked;
          submitBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
        }
        if (warningEl) warningEl.hidden = !blocked;
      });
    }

    refresh();

    var scope = getScope(productFormEl);
    scope.querySelectorAll('input[name="selling_plan"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        console.log('[SubscriptionGuard] Radio changed:', radio.dataset.radioType);
        refresh();
      });
    });
  }

  function initAll() {
    console.log('[SubscriptionGuard] initAll — searching product-form[data-product-id]');
    document.querySelectorAll('product-form[data-product-id]').forEach(refreshUIForForm);
  }

  // On page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when quick-add modal opens or dynamic content loaded
  document.addEventListener('subscription:reinit', function () {
    console.log('[SubscriptionGuard] subscription:reinit — re-initializing forms');
    initAll();
  });

  // Listen to cart updates to refresh the UI state
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      console.log('[SubscriptionGuard] cartUpdate detected — refreshing forms');
      setTimeout(initAll, 100);
    });
  }

})();
